import React, { useState } from 'react'
import { AddressAutocomplete } from '../../../screens/Supplier/GoogleMap'
import CollapsableAddress from '../../../screens/Supplier/SupplierApplication/flow/CollapsableAddress'
import { supplier } from '@linqpal/common-frontend'
import { getSnapshot, types } from 'mobx-state-tree'
import { dictionaries, editableModel } from '../../../../../models'
import { ButtonFlowNext } from '../../molecules/ButtonFlowNext'
import { Observer } from 'mobx-react'
import { View } from 'react-native'
import LinkLabel from '../../../ui/atoms/LinkLabel'
import { useNavigation, useRoute } from '@react-navigation/native'
import { paths } from '../../../screens/links'

export const ProjectAddressInput = ({
  onValue,
  save,
  currentData,
  document,
}) => {
  const navigation = useNavigation()
  const route = useRoute()
  const addressViews = (self) => ({
    get canSave() {
      return self.address && self.city && self.state && self.zip && true
    },
  })

  const [manualAddress, setManualAddress] = useState(false)

  const dataModel = types
    .compose(
      types.model({
        address: '',
        unitNumber: '',
        city: '',
        state: '',
        zip: '',
        lat: types.maybeNull(types.number),
        lng: types.maybeNull(types.number),
      }),
      editableModel(),
    )
    .views(addressViews)

  const { Input, Picker, alphabetsConverter } = supplier.ui
  const data = dataModel.create(currentData?.content)
  return (
    <View style={{ margin: 20 }}>
      <CollapsableAddress model={data}>
        {manualAddress ? (
          <Input label="Street Address" model={data} name="address" />
        ) : (
          <AddressAutocomplete model={data} />
        )}
        <View style={{ alignSelf: 'flex-end' }}>
          <LinkLabel onPress={() => setManualAddress(!manualAddress)}>
            {manualAddress
              ? 'Use Autocompleted Address'
              : 'Enter Address Manually'}
          </LinkLabel>
        </View>
        <Input
          label="Unit number (Apt, Bldg #)"
          model={data}
          name="unitNumber"
        />
        <Input
          label="City"
          name="city"
          model={data}
          converter={alphabetsConverter}
          mandatory
        />
        <Picker
          label="State"
          name="state"
          model={data}
          options={dictionaries.STATES}
          mandatory
        />
        <Input
          label="Zip Code"
          model={data}
          name="zip"
          inputMask="99999"
          mandatory
        />
      </CollapsableAddress>
      <Observer>
        {() => (
          <ButtonFlowNext
            containerStyle={{ marginTop: 40 }}
            disabled={!data.canSave}
            onPress={() => onValue(getSnapshot(data), null, data.canSave)}
            save={save}
            onBack={() =>
              route.params?.invoice
                ? navigation.navigate(paths.InvoicesToPay._self)
                : navigation.navigate(paths.Console.Projects.List)
            }
            document={document}
          />
        )}
      </Observer>
    </View>
  )
}
